import { render, staticRenderFns } from "./ModalImprimirEtiqueta.vue?vue&type=template&id=32f134f3"
import script from "./ModalImprimirEtiqueta.vue?vue&type=script&lang=js"
export * from "./ModalImprimirEtiqueta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports